/**
 * Stream plain-text / script-tagged output from PHP engine endpoints (same as legacy XHR).
 */
export function stripEngineScripts(raw) {
  return raw.replace(/<script>[\s\S]*?<\/script>/gi, '').trim();
}

export function parseProgressPct(raw, barFn = 'setBar') {
  const re = new RegExp(`${barFn}\\((\\d+)\\)`, 'g');
  const matches = raw.match(re);
  if (!matches?.length) return null;
  const last = matches[matches.length - 1].match(/\d+/);
  return last ? parseInt(last[0], 10) : null;
}

export function xhrStream(url, formData, { onLog, onProgress, barFn = 'setBar', logPrefix = '' } = {}) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);

    const parse = () => {
      const raw = xhr.responseText;
      const clean = stripEngineScripts(raw);
      onLog?.((logPrefix || '') + clean);

      const pct = parseProgressPct(raw, barFn);
      if (pct != null) onProgress?.(pct);
    };

    xhr.onprogress = parse;
    xhr.onload = () => {
      parse();
      resolve(stripEngineScripts(xhr.responseText));
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.send(formData);
  });
}